// eslint-disable-next-line import/prefer-default-export
export const baseSortableOptions = {
  draggable: '[data-draggable="true"]',
  filter: '[data-draggable="false"]',
  animation: 100,
  swapThreshold: 1,
  ghostClass: 'sortable-ghost',
};
